module.exports = __webpack_public_path__ + "static/media/cancel.e1140b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/cancel.png
// module id = 2477
// module chunks = 0